var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 30.707a1 1 0 001.414 0l6.364-6.364a1 1 0 00-1.414-1.414L22 28.586l-5.657-5.657a1 1 0 00-1.414 1.414l6.364 6.364zM21 14v16h2V14h-2z",
    fill: "currentColor"
  })));
}

export default SvgDownArrow;